import Store from '@/global/dejaVue/store'
import { AccesSecurise } from './AccesSecurise'
import Company from './company'
import LocalSettings from './localSettings'
import { Pastilles } from './Pastilles'
import { ProduitPossiblePourPMNOutput } from './ProduitPossiblePourPMNOutput'
import User from './user'
import { UserForSelection } from './UserForSelection'

export default class Database extends Store {
    public account = new User()
    public users = new Array<User>()
    public usersForSelection = new Array<UserForSelection>()
    public companies = new Array<Company>()
    public pastilles = new Pastilles();
    public produits = new Array<ProduitPossiblePourPMNOutput>()

    public settings = new LocalSettings()
    public accesSecurise = null as null | AccesSecurise

    public baseState() {
        return new Database()
    }

    public signature() {
        return 'biobank'
    }

    public feed(options?: any) {
        if (options?.account) this.account.feed(options.account)
        if (options?.users) this.users = options.users.map((x: any) => new User(x))
        if (options?.usersForSelection) this.usersForSelection = options.usersForSelection
        if (options?.companies) this.companies = options.companies
        if (options?.pastilles) this.pastilles = options.pastilles
        if (options?.produits) this.produits = options.produits
        return this
    }
}
